import React from "react";

const MapLoader = () => {
    return (<div style={{ position: 'relative' }}>
        <div style={{
            zIndex: '1000',
            position: 'absolute',
            top: '30px',
            right: '10px'
        }}>
            <div className="c-reactloader dark status o-col-2"><i className="loader"/></div>
        </div>
    </div>);
};

export default MapLoader;